import { Panel, PanelType } from '@fluentui/react';
import { useDownloadData } from '../context';
import { useTranslation } from 'react-i18next';
import { DownloadFooter } from './DownloadFooter';
import { FileTypeCard } from './FileTypeCard';
import { FeedbackFivePointEveryXQuarters } from '@msrceng/component';

/**
 * Renders a panel for selecting a file type for the exported spreadsheet.
 */
export const DownloadPanel = () => {
  const [t] = useTranslation(['translation', 'search', 'download']);
  const { open, setOpen } = useDownloadData();
  return (
    <Panel
      type={PanelType.medium}
      {...{
        isOpen: open,
        headerText: t('Download', { ns: 'search' }),
        onDismiss: () => setOpen(false),
        isLightDismiss: true,
        isFooterAtBottom: true,
        onRenderFooterContent: () => <DownloadFooter />,
        closeButtonAriaLabel: t('Close', { ns: 'translation' }),
      }}
      styles={{
        content: { paddingBottom: '1px' },
      }}
    >
      <p>
        {t(
          'instructions',
          'Select file format to download a copy of this dataset. ',
          {
            ns: 'download',
          }
        )}
      </p>
      <FileTypeCard />
      <div style={{ padding: '1em 0' }}>
        <FeedbackFivePointEveryXQuarters
          source='SUG-Download'
          quartersBetweenDismiss={1}
          quartersBetweenRequests={1}
        >
          {t('CSAT', { ns: 'translation' })}
        </FeedbackFivePointEveryXQuarters>
      </div>
    </Panel>
  );
};
